import { Locale } from '@headless-workspace/config';
import { Repository, Result, ResultFailureFromApiError, ResultSuccess } from '@headless-workspace/core-domain';
import {
    memoryCacheAuthStrategy,
    memoryCacheQueryParamStrategy,
    memoryCacheRefreshTokenStrategy,
} from '@headless-workspace/data';
import { ContentAssetValue, mapContentAssetsValue } from './ContentAssetValue';
import { ContentAssetsDTO } from './ContentAssetsDTO';

const CONTENT_ASSETS_SEPARATOR = ';';

export interface ContentAssetsRepositorySpec {
    getAssets(locale: Locale, ids: string[]): Promise<Result<ContentAssetValue[]>>;
}

export class ContentAssetsRepository extends Repository implements ContentAssetsRepositorySpec {
    path = '/content/v1';

    constructor() {
        super(memoryCacheAuthStrategy, memoryCacheRefreshTokenStrategy, memoryCacheQueryParamStrategy);
    }

    async getAssets(locale: Locale, ids: string[]): Promise<Result<ContentAssetValue[]>> {
        try {
            const response = await this.datasource.getResource(`${this.path}/assets`, {
                locale,
                ids: ids.join(CONTENT_ASSETS_SEPARATOR),
            });
            const contentAssets = ContentAssetsDTO.parse(response);
            return ResultSuccess(mapContentAssetsValue(contentAssets));
        } catch (error) {
            const apiError = this.handleApiError(error);
            return ResultFailureFromApiError(apiError, { locale });
        }
    }
}
